import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserLayout from './components/UserLayout';
import Home from './components/Home';
import About from './components/About';
import Service from './components/Service';
import ContactUs from './components/ContactUs';
import WomanProduct from './components/WomanProduct';
import WomanProductDetails from './components/WomanProductDetails';
import ManProduct from './components/ManProduct';
import ManProductDetails from './components/ManProductDetails';
// import "/css/style.css";
// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<UserLayout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/man/:category" element={<ManProduct />} />
          <Route path="/man/:category/:id" element={<ManProductDetails />}/>
          <Route path="/woman/:category" element={<WomanProduct />} />
          <Route path="/woman/:category/:id" element={<WomanProductDetails />}/>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
